"use strict";
var Observable_1 = require('../../Observable');
var timeInterval_1 = require('../../operator/timeInterval');
Observable_1.Observable.prototype.timeInterval = timeInterval_1.timeInterval;
//# sourceMappingURL=timeInterval.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/rxjs/add/operator/timeInterval.js
// module id = ./node_modules/rxjs/add/operator/timeInterval.js
// module chunks = 0